<template>
    <div class="c-policy">
        <h2>
            Privacy Policy
        </h2>

        <p>
            TBA.
        </p>
    </div>
</template>

<script>
    export default {
        name: 'privacy-policy',
    }
</script>


// WEBPACK FOOTER //
// PrivacyPolicy.vue?7eafa60c